import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  ButtonSize,
  ButtonVariant,
} from '../../shared/as-components/button/button.component';
import { ContentManagerService } from '../../services/content-manager.service';

@Component({
  selector: 'app-language-change-dialog',
  template: `
    <div [attr.data-theme]="'dark'" class="changeLanguageBlock">
      <div class="dialog-title">{{ 'creator.unsavedChanges' | translate }}</div>
      <div>
        <p>{{ 'creator.changeLanguageMessage' | translate }}</p>
      </div>
      <div class="btnLanguage" align="end">
        <as-button
          [useSubmitBehavior]="true"
          [size]="btnSize.Large"
          [variant]="btnVariant.Ghost"
          (click)="onCancel()"
          [label]="'creator.cancelButton' | translate"
          [customClass]="'w-100'"
        ></as-button>

        <as-button
          [useSubmitBehavior]="true"
          [size]="btnSize.Large"
          [variant]="btnVariant.Outline"
          (click)="onSave()"
          [label]="'creator.titleButtonlangSave' | translate"
          [customClass]="'w-100'"
        ></as-button>

        <as-button
          [useSubmitBehavior]="true"
          [size]="btnSize.Special"
          [variant]="btnVariant.Primary"
          (click)="onSaveAndStay()"
          [label]="'creator.titleButtonlangNotSave' | translate"
          [customClass]="'w-100'"
        ></as-button>
      </div>
    </div>
  `,
  styleUrl: './language-change-dialog.component.scss',
  standalone: false,
})
export class LanguageChangeDialogComponent {
  btnSize = ButtonSize;
  btnVariant = ButtonVariant;

  constructor(
    private ref: MatDialogRef<LanguageChangeDialogComponent>,
    private contentManagerService: ContentManagerService,
    @Inject(MAT_DIALOG_DATA)
    public data: { nextLang: string }
  ) {}

  close(action: 'save-change' | 'change' | 'cancel') {
    const params = {
      action: action,
    };
    this.ref.close(params);
  }

  onSave() {
    console.log('onSave');
    this.contentManagerService.synchronizeChangedStructures();
    this.close('save-change');
  }

  onSaveAndStay() {
    console.log('onSaveAndStay');
    this.contentManagerService.synchronizeChangedStructures();
    this.close('change');
  }

  onCancel() {
    console.log('onCancel=');
    this.close('cancel');
  }
}
